import { LazyQueryResult, QueryResult } from '@apollo/client';
import { createPendingDataEntries } from './createPendingDataEntries';

type Opts<Q extends QueryResult | LazyQueryResult<any, any>, V> = {
  selector: (value: Q['data']) => V[];
  withPendingState?: boolean;
  ignoreExistingData?: boolean;
};

export const extractListDataFromQuery = <
  Q extends QueryResult | LazyQueryResult<any, any>,
  V,
>(
  query: Q,
  opts: Opts<Q, V>,
) => {
  const entries = opts.selector(query.data);
  if (opts.withPendingState === false)
    return entries.map((e) => ({ item: e, pending: false }));
  let data =
    (entries.length === 0 || opts.ignoreExistingData) && query.loading
      ? createPendingDataEntries<V, 'item'>('item', 3)
      : entries.map((e) => ({ item: e, pending: false }));
  if (query.loading && entries.length > 0) {
    data = data.concat(createPendingDataEntries<V, 'item'>('item', 3));
  }
  return data;
};
